import React, { Component } from "react";
import { connect } from "react-redux";

import { loginUser } from "../../reducers/user";

import Item from "./TemplateItem";

import "./Templates.css";

class Templates extends Component {
  componentDidUpdate(oldProps) {
    // console.log(oldProps, this.props);
    if (
      oldProps.loading !== this.props.loading &&
      !this.props.loading &&
      !!this.props.store
    ) {
      window.location.href = `/editor/${this.props.store.storeId}`;
    }
  }
  render() {
    return (
      <div id="templates-container">
        <div className="templates-container-title">
          <h1>Scegli il template dell'eCommerce che preferisci</h1>
        </div>
        <div id="templates-items-container">
          {this.props.templates.map((template, idx) => (
            <Item
              showEdit={!!this.props.user}
              image={template.backgroundImg}
              previewUrl={"/template"}
              background={template.brandColor}
              nome={template.siteName}
              id={template.storeId}
              key={idx}
            />
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  templates: state.template.data,
  user: state.user.data.user,
  store: state.store.singleStore,
  loading: state.store.loading,
});

export default connect(mapStateToProps, { loginUser })(Templates);
